import React from 'react';
import ForgotPassword from './ForgotPassword';
import ThemeErrorBoundary from '../../theme/ThemeErrorBoundary';
import { StyledComponentsIntegration } from '../../theme/StyledComponentsIntegration';

/**
 * ForgotPasswordWrapper
 * 
 * This component wraps the ForgotPassword component with the StyledComponentsIntegration
 * to ensure that styled-components has access to the theme.
 */
const ForgotPasswordWrapper: React.FC = () => {
  return (
    <ThemeErrorBoundary>
      <StyledComponentsIntegration>
        <ForgotPassword />
      </StyledComponentsIntegration>
    </ThemeErrorBoundary>
  );
};

export default ForgotPasswordWrapper;